module.exports = __webpack_public_path__ + "static/media/Group 17.b9cf9a5c.svg";